<template>
	<div class="app-loader">
		<div class="app-loader__content">
			<v-progress-circular
				class="app-loader__spinner"
				size="60"
				width="7"
				indeterminate
			></v-progress-circular>
			<p class="app-loader__title">{{ tituloLoading }}</p>
		</div>
	</div>
</template>

<script>
	import { Component, Vue } from "vue-property-decorator";

	/**
	 * ShowLoading — pantalla full-height de "cargando vista" con
	 * spinner + título.
	 *
	 * Usa la clase global .app-loader (Fase 35j) que vive en
	 * src/assets/components/_appComponents.scss y responde al theme
	 * dinámico via var(--theme-primary) y var(--theme-text). Antes
	 * tenía el spinner color hardcoded a $rc-prim-n1 y media queries
	 * scoped duplicadas — ambos ahora consolidados en la clase global.
	 */
	@Component({
		props: {
			tituloLoading: String
		},
	})
	export default class ShowLoading extends Vue {}
</script>
